module.exports = __webpack_public_path__ + "static/enterChina-998a16a32b65ecc1f90b9be72dc77169.jpg";